(function () {
    'use strict';

    angular
        .module('app')
        .directive('searchFilter', searchFilterDirective);

    function searchFilterDirective() {
        var directive = {
            restrict: 'AE',
            scope: {
                results: '=',
                ngModel: '=',
                ngChange: '&',
                apiEndpoint: '@',
                expandWith: '@',
                selectedValue: '=',
                wantedAttribute: '@'
            },
            controller: searchFilterDirectiveController,
            controllerAs: 'vm',
            bindToController: true,
            templateUrl: '/templates/directives/search-filter.directive.html',
        };

        return directive;
    }

    searchFilterDirectiveController.$inject = ['global', 'i18n', '$element', 'API', 'debug',];

    function searchFilterDirectiveController(global, i18n, $element, API, debug) {
        var vm = this;
        vm.search = '';
        vm.searchVisual = '';
        vm.selectedValue = '';
        vm.isOpen = false;
        vm.selectResult = selectResult;
        vm.open = open;
        vm.close = close;
        vm.change = change;
        vm.keyUp = keyUp;
        vm.clearSearch = clearSearch;
        vm.isDesktop = global.isDesktop;
        vm.searchResults = {};
        vm.searchPromises = [];
        vm.placeholder = 'SEARCH';
        vm.loadingState = {
            resourceIsLoading: false
        };

        i18n.get(vm.placeholder).then(function (text) {
            vm.placeholder = text;
        });

        function change(skipCharacterLimit) {
            if (vm.apiEndpoint) {
                var promise = null,
                    searchObject = {
                        'page': vm.page,
                        'per-page': vm.perPage,
                    };
                if (vm.expandWith) {
                    searchObject.expand = vm.expandWith;
                }
                if (vm.search && (vm.search.length > 2 || skipCharacterLimit)) {
                    searchObject.q = vm.search;
                    promise = API[vm.apiEndpoint].search(searchObject).$promise;
                } else {
                    clearSearch();
                }

                if (promise) {
                    vm.loadingState.resourceIsLoading = true;
                    promise.then(function (response) {
                        vm.searchResults = response.items;
                        vm.listMeta = response._meta;
                        vm.loadingState.resourceIsLoading = false;
                    }, function (response) {
                        debug.log(response);
                    });
                }
            } else {
                debug.error('No endpoint given.');
            }
        }

        function clearSearch() {
            vm.searchResults = [];
            vm.selectedValue = '';
            vm.searchVisual = '';
        }

        function keyUp(event) {
            if (event.keyCode === 13) {
                vm.change(true);
            }
        }

        function selectResult(result) {
            if (result.id) {
                vm.searchVisual = result.id;
            }
            if (result.name) {
                vm.searchVisual += ' - ' + result.name;
            }
            if (result.district) {
                vm.searchVisual += ' - ' + result.district;
            }
            if (vm.wantedAttribute) {
                vm.selectedValue = result[vm.wantedAttribute];
            } else {
                // No value specified for directive, going with id
                vm.selectedValue = result.id;
            }
            vm.close();
        }

        function open() {
            vm.isOpen = true;
            setTimeout(function () {
                var element = $element[0];
                element.querySelector('input').focus();
            }, 250);
        }

        function close() {
            vm.isOpen = false;
        }
    }
})();